import React from 'react';
import styled from '@emotion/styled';
import { Typography, Paper } from '@mui/material';
import { Link } from 'gatsby';

const SFooter = styled.footer`
  width: 100%;
  height: 5.5rem;

  display: flex;
  justify-content: space-around;
  padding: 48px;
  margin-top: var(--small);
`;

export const Footer = ({ showContact = false }) => (
  <SFooter as={Paper} square>
    <Typography>© Sweat.no {new Date().getFullYear()}</Typography>
    <Link to="/om-sweat/">Om oss</Link>
    {showContact ? (
      <Link to="kontakt/" rel="nofollow">
        Kontakt oss
      </Link>
    ) : null}
  </SFooter>
);
